import script from "./MyClassFile.vue?vue&type=script&setup=true&lang=js"
export * from "./MyClassFile.vue?vue&type=script&setup=true&lang=js"

import "./MyClassFile.vue?vue&type=style&index=0&id=62c6b0b2&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/web-h5-hade/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-62c6b0b2"]])

export default __exports__